import { useState, useCallback } from "react";
import { type TreeNodeInfo } from "@focus/focusUI";

export function useTree<T>() {
  const [selected, setSelected] = useState<T | null>(null);
  const [collapsed, setCollapsed] = useState<Record<string, boolean>>({});

  const toggleNode = useCallback((id: string) => {
    setCollapsed((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  }, []);

  const expandNode = useCallback((id: string) => {
    setCollapsed((prev) => ({
      ...prev,
      [id]: false,
    }));
  }, []);

  const collapseNode = useCallback((id: string) => {
    setCollapsed((prev) => ({
      ...prev,
      [id]: true,
    }));
  }, []);

  const selectNode = useCallback((node: TreeNodeInfo<any>) => {
    const data = node.nodeData;

    if (data?.type && data.type === "container") {
      toggleNode(node.id as string);
      return;
    }

    setSelected(data);
  }, []);

  const setInitialSelected = useCallback((data: T) => {
    setSelected((prev) => prev ?? data);
  }, []);

  return {
    selected,
    collapsed,
    selectNode,
    expandNode,
    collapseNode,
    setInitialSelected
  };
}
